import { Col, Select } from '@rematter/ui-web';
import { useToast } from '@rematter/ui-web/hooks';
import { useAtomValue, useSetAtom } from 'jotai';
import { LucideGlobe } from 'lucide-react';

import { patchScopedSettingValuesMutationAtom } from '../../_graphql/mutationPatchScopedSettingValues';
import { useTranslations } from '../../i18n/useTranslations';
import { FormSection } from '../_shared/FormSection';

import { SidebarModuleOrderSection } from './SidebarModuleOrderSection';

import { useIdentity } from '~/shared/hooks/useIdentity';
import {
  $allSettingsGroups,
  $userLanguageSetting,
} from '~/shared/state/settings.state';

const LANGUAGE_OPTIONS = [
  { key: 'en', label: 'English' },
  { key: 'es', label: 'Spanish' },
  { key: 'pt', label: 'Portuguese' },
];

const $patchLanguage = patchScopedSettingValuesMutationAtom({
  onSuccess: (get) => {
    get($allSettingsGroups).refetch();
  },
});

export const PreferencesView = () => {
  const t = useTranslations();
  const { user } = useIdentity();
  const currentLanguage = useAtomValue($userLanguageSetting);
  const patchLanguage = useSetAtom($patchLanguage);
  const toast = useToast();

  const handleLanguageChange = async (value: string | number) => {
    if (!user) return;

    try {
      await patchLanguage({
        scope: 'User',
        objectId: user.id,
        values: { 'general.language': value as string },
      });
      toast.success(t.preferencesView.messages.saveSuccess);
    } catch {
      toast.error(t.preferencesView.messages.saveError);
    }
  };

  return (
    <Col gap4 className="@PreferencesView h-full p-5">
      <FormSection icon={LucideGlobe} title={t.preferencesView.title}>
        <div className="grid w-[200px] gap-4">
          <Select
            label={t.preferencesView.language.label}
            description={t.preferencesView.language.description}
            isDisabled={!user}
            value={currentLanguage ?? 'en'}
            options={LANGUAGE_OPTIONS}
            onChange={handleLanguageChange}
          />
        </div>
      </FormSection>
      <SidebarModuleOrderSection />
    </Col>
  );
};
